import { AnnualUserPlanningDay } from "./AnnualUserPlanningDay";
import { dateToAAAAMMJJ, dateWithoutHour, firstLetterCapital, intToMonth } from "../../functions";

const AnnualUserPlanning = (props) => {
    const { startDate, endDate, planning, selectedTimeSlots, publicHolidays } = props;

    const mupStartDate = dateWithoutHour(startDate);
    const mupEndDate = dateWithoutHour(endDate);

    function handleClickDate(val, ctrlKey) {
        props.onClickDate(val, ctrlKey);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(tsId, ctrlKey);
    };

    const planningWithDate = (aMonth) => {
        let aDate = dateWithoutHour(mupStartDate);
        let arrayOfDate = [];
        while (aDate <= mupEndDate) {
            if (aDate.getMonth() === (aMonth - 1)) { arrayOfDate.push(dateWithoutHour(aDate)); }
            aDate.setDate(aDate.getDate() + 1);
        }
        const aResult = arrayOfDate.map((aDate) => {
            const aDay = {
                datePlanning: dateWithoutHour(aDate),
                timeSlots: planning && planning.filter((pl) => {
                    return (dateWithoutHour(pl.start_date).toDateString() == dateWithoutHour(aDate).toDateString())
                }),
            }
            return aDay;
        })
        return aResult;
    }

    const months = [...new Array(12)].map((val, index) => (index + 1));
    const days = [...new Array(31)].map((val, index) => (index + 1));
    let prevMonth = -1;

    const isPublicHoliday = (date) => {
        if (!publicHolidays) return false;
        return publicHolidays.some(holiday => holiday.date == dateToAAAAMMJJ(date, "-"));
    }

    const render = (
        <div className="flex m-0 text-xs border-t border-r">

            {months.map((month) =>
                <div className={"w-1/12 border-l m-0"} key={month}>
                    <div className={"w-full flex bg-slate-100 border-b justify-center py-1 h-6 truncate"}>
                        <span className="hidden md:block">{firstLetterCapital(intToMonth(month))}</span>
                        <span className="block md:hidden">{firstLetterCapital(intToMonth(month).slice(0, 3))}</span>
                    </div>
                    {planningWithDate(month).map((day) => (
                        
                            <AnnualUserPlanningDay
                                key={day.datePlanning}
                                datePlanning={day.datePlanning}
                                timeSlots={day.timeSlots}
                                onClickDate={handleClickDate}
                                onClickTimeSlots={handleClickTimeSlots}
                                selectedTimeSlots={selectedTimeSlots}
                                isPublicHoliday={isPublicHoliday(day.datePlanning)}
                            />
                        

                    ))
                    }
                </div>
            )}
        </div>
    )

    return render;
};

export default AnnualUserPlanning;